// extracted by mini-css-extract-plugin
export default {"link":"z8dt4c","root":"HRtdiM","label":"Pd7m5i"};